// extracted by mini-css-extract-plugin
export default {"wrapper":"ListSerials_wrapper__TsHCN","content":"ListSerials_content__6nDhL"};